<template>
	<div>
		<div class="subheader position-relative">
			<h1 class="text-center text-white position-relative">
                {{ $t("navbar.booking") }}
            </h1>
		</div>
        <div class="text-black pt-5">
    		<div class="container pt-md-5">
    			<div class="row pt-5">
    				<div class="col-lg-8 offset-lg-2 col-12">
    			  		<h2>{{ $t("booking.text") }}</h2>
                        <p>{{ $t("booking.subtext") }}</p>
    				</div>
                </div>
            </div>
        </div>
	</div>
</template>

<script>
	import { Bus }  from "../bus.js";

    export default {
        data: function(){
            return {
                lang: ""
            }
        },
        created: function(){
            this.lang = this.$i18n.locale;
        },
        mounted: function(){
            var self = this;
            Bus.$on("lang", (lang) => {
                if(lang === "hu"){
                    self.lang = "hu";
                }else{
                    self.lang = "en";
                }
            });
        },
        watch: {
            lang: function(){
                if(this.lang === "hu"){
                    history.pushState('', "Sikeres foglalás", "https://ijaszat.eu/sikeres-foglalas");
                }else{
                    history.pushState('', "Booking success", "https://ijaszat.eu/booking-success");
                }
            }
        },
    };
</script>


// WEBPACK FOOTER //
// src/components/Success.vue